import { useEffect } from 'react'
import { useLoading } from '../contexts/LoadingContext'
import { setLoadingHandler } from '../services/api'

export const useGlobalLoading = () => {
  const { isLoading, loadingMessage, setLoading, startLoading, stopLoading } = useLoading()

  useEffect(() => {
    // Connect the API service to the loading context
    setLoadingHandler(setLoading)
  }, [setLoading])

  return {
    isLoading,
    loadingMessage,
    setLoading,
    startLoading,
    stopLoading,
  }
}

// Hook for component-specific loading states
export const useComponentLoading = () => {
  const { startLoading, stopLoading } = useLoading()

  const withLoading = async <T>(
    asyncFunction: () => Promise<T>,
    message: string = 'Loading...'
  ): Promise<T> => {
    try {
      startLoading(message)
      const result = await asyncFunction()
      return result
    } finally {
      stopLoading()
    }
  }

  return {
    withLoading,
    startLoading,
    stopLoading,
  }
}
